<template>
    <b-modal ref="my-modal"
             id="my-modal"
             centered
             no-close-on-backdrop
             no-close-on-esc
             hide-header-close
             :visible="isVisible">
        <template slot="modal-title">
            <i title="Upload File" class="fa fa-file-upload" />
            <label class="ml-2">{{ modalTitle }}</label>
        </template>

        <label><span class="lbl-obg">*</span>{{ fileLabel }}</label>
        <b-form-file
            v-model="file"
            :placeholder="fileInputLabel"
            v-on:input="resetConfirmButton()"
        ></b-form-file>
        <div class="text-center mt-1">
            <b-button variant="outline-primary" :disabled="!Boolean(file)" v-on:click="processFile(file)">
                <div class="d-inline-flex">
                    <i class="fa fa-cog" />
                    <span>{{ buttonUpload }}</span>
                </div>
            </b-button>
        </div>
        <div class="mt-2" v-if="fileProcessedResponse === false">
            <b-table 
                thead-class="table-active"
                bordered
                :fields="gridFields"
                :items="errorArray">
            </b-table>
        </div>

        <template slot="modal-footer">
            <b-button variant="primary" :disabled="fileProcessedResponse !== true" v-for="(confirmButton, index) in confirmButtons" v-bind:key="index" v-on:click="confirm()">
                <i class="fa fa-check-square"/>
                <span>{{ $t(confirmButton.label) }}</span>
            </b-button>
            <b-button variant="outline-secondary" v-for="(cancelButton, index) in cancelButtons" v-bind:key="index + 1" v-on:click="cancelModal(cancelButton.id)">
                <span>{{ $t(cancelButton.label) }}</span>
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
    name: "mmf-upload-modal",
    data: function() {
        return {
            file: null,
            gridFields: [
                {key: 'message', label: 'Error', class: 'text-center'},
                {key: 'observation', label: 'Row/Cell', class: 'text-center'}
            ]
        }
    },
    computed: {
        ...mapState({
            data: state => state.uploadModal.data,
            modalTitle: state => state.uploadModal.modalTitle,
            fileLabel: state => state.uploadModal.fileLabel,
            fileInputLabel: state => state.uploadModal.fileInputLabel,
            buttonUpload: state => state.uploadModal.buttonUpload,
            cancelButtons: state => state.uploadModal.cancelButtons,
            confirmButtons: state => state.uploadModal.confirmButtons,
            isVisible: state => state.uploadModal.isVisible,
            fileProcessedResponse: state => state.uploadModal.fileProcessedResponse,
            errorArray: state => state.uploadModal.errorArray,
        })
    },
    methods: {
        resetConfirmButton() {
            this.$store.commit("uploadModal/setFileProcessedResponse", null)
        },
        confirm() {
            this.cancelModal()
            this.$emit('confirm', this.data)
        },
        ...mapActions("uploadModal", ['cancelModal', 'processFile'])
    }
}
</script>
